export default "__VITE_ASSET__llC4TvVH__"